import Image from 'next/legacy/image';

export default function NotionPaste() {
  return (
    <li>
      <h3 id="paste-notion">Paste it in Notion Page</h3>
      <p>
        Paste the link in Notion page and click on <code>Create embed</code> from the menu that pops
        up.
      </p>
      <Image src="/guides/notion-paste-1.png" width={690} height={258} alt="paste" />
      <p>OR</p>
      <p>
        Type <code>/</code> to get the commands menu and look for <code>Embed</code> in it. Paste
        the link you've copied here.
      </p>
      <Image src="/guides/notion-paste-2.png" width={1502} height={600} alt="paste" />
    </li>
  );
}
